import React from 'react';
import {
  TableFilters,
  TableFilterSelect,
  InputContainer,
  SearchableSelect,
} from '../../design-system';
import { containerTypes, INPUT_ERRORS, offerStatusOptions, listModeOptions } from '../../const';
import { extendContainerValidator, showToRoles } from '../../utils';
import { belongsToOptions, clientYardService } from '../../services';
import { User } from '../../types';
import { i18n } from '../../i18n';
import { useSaveFilters } from '../../hooks';

interface Props {
  user: User;
  offerDirection?: 'sent' | 'received';
  number?: string;
  type?: string;
  status?: string;
  buyerClientId?: string;
  listMode?: string;
  setStates: any;
}

export const Filters: React.FC<Props> = ({
  user,
  offerDirection,
  number = '',
  type,
  status,
  buyerClientId = '',
  listMode,
  setStates,
}: Props) => {
  const [oldFilters, setOldFilters] = useSaveFilters('belongs-to', true);

  return (
    <TableFilters>
      {!Array.isArray(number) && (
        <InputContainer
          label={i18n.t('label.containerNumber')}
          data-size={'medium'}
          defaultValue={number}
          onChange={(e) => {
            const value = e.target.value.toUpperCase();
            setStates('number', value);
          }}
          helperText={
            number.length !== 0 && number.length < 3
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_MIN
              : !extendContainerValidator(number)
              ? INPUT_ERRORS.NOT_VALID.CONTAINER_NUMBER_SHORT
              : ''
          }
          alwaysShowHelperText
        />
      )}
      <TableFilterSelect
        label={i18n.t('label.type')}
        options={containerTypes}
        value={type}
        onChange={(e) => setStates('force', { type: e.target.value })}
      />
      {!Array.isArray(number) && (
        <TableFilterSelect
          label={i18n.t('label.status')}
          options={offerStatusOptions(offerDirection)}
          value={status}
          onChange={(e) => setStates('force', { status: e.target.value })}
        />
      )}
      {showToRoles('adminRead', user) && (
        <SearchableSelect
          selectedOptionLabel={oldFilters.clientName}
          label={i18n.t('label.buyerClient')}
          onSelect={(obj: any) => {
            setOldFilters({ ...oldFilters, clientName: obj.label });
            setStates('force', { buyerClientId: obj.id });
          }}
          queryFn={() => {
            if (
              showToRoles(
                [
                  'YARD_COMPANY_ADMIN',
                  'YARD_COMPANY_EMPLOYEE',
                  'YARD_COMPANY_VIEWER',
                  'YARD_MANAGER',
                  'YARD_DISPATCHER',
                ],
                user,
              )
            )
              return clientYardService.assignedClients({
                yardCompanyId: user.yardCompanyEmployee?.yardCompanyId,
                id: user.yardEmployee?.yardId,
              });

            if (showToRoles(['SUPER_ADMIN'], user)) return belongsToOptions.Client('', true);

            return () => [];
          }}
          queryKey={[
            'clients',
            'assigned-clients' +
              user.yardEmployee?.yardId +
              user.yardCompanyEmployee?.yardCompanyId,
          ]}
          selectedAreasEqaul={{ key: 'id', keys: [buyerClientId] }}
          withClearButton
        />
      )}
      {Array.isArray(number) && (
        <TableFilterSelect
          label={i18n.t('label.listMode')}
          options={listModeOptions}
          value={listMode}
          onChange={(e) => setStates('force', { listMode: e.target.value })}
        />
      )}
    </TableFilters>
  );
};
